import { FormSelectId, FormSelectIdProps } from '@nexelem/form-components';
import { useCustomTranslation } from '../../../hooks';
import { useProductionQueues } from '../../../queryHooks/useProductionsQueues';

type FormProductionQueueSelectProps = Omit<FormSelectIdProps, 'label' | 'options' | 'placeholder'>;

export const FormProductionQueueSelect = ({ name, disableClear, maxWidth = 560 }: FormProductionQueueSelectProps) => {
  const { t, tWrapper } = useCustomTranslation('products.productionPlan.drawerFilters');
  const { data, isLoading } = useProductionQueues();

  const options = data?.map((queue) => {
    return { id: queue.id ?? 0, label: queue.name };
  });

  return (
    <FormSelectId
      isMultiple
      disableClear={disableClear}
      label={tWrapper('queues')}
      loading={isLoading}
      maxWidth={maxWidth}
      name={name}
      options={options}
      placeholder={t('components.filters.searchOrSelect')}
    />
  );
};
